import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar_poc'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/bg.jpg'

export default function PagePrivacy() {
  return (
    <>
     <Navbar/>
     
     <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
       <div className="bg-overlay bg-overlay-white"></div>
       <div className="container">
           <div className="row mt-5 text-center align-items-center">
               <div className="col-sm-6">
                   <div className="text-sm-start">
                       <div className="page-next-level">
                           <h4 className="title">Privacy Page</h4>
                           <p className="text-muted mb-0">Learn how we collect, use, and protect your personal information when you interact with Pioneer One Global.</p>                                        
                       </div>
                   </div>
               </div>
 
               <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                   <div className="page-next-level text-sm-end">
                       <ul className="page-next ps-0 mb-0">
                           <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item">
                               <span className="text-uppercase text-primary fw-bold">Privacy Page</span> 
                           </li> 
                       </ul>
                   </div>
               </div>
           </div>
       </div> 
     </section>
     <ShapeTwo/>

      <section className="section">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <h5>Overview :</h5>
                    <p className="text-muted"> Pioneer One Global (POG), a DBA of Minmini Corporation ("we," "our," or "us"),
        is committed to protecting your privacy. This Privacy Policy explains how we
        collect, use, and protect your information when you interact with our website or contact us.
</p>


<h5>1. Information We Collect</h5>
      <ul>
        <li><strong>Personal Information:</strong> We may collect your name, email, company name, and any other details you provide.</li>
        <li><strong>Usage Data:</strong> We may collect non-identifying information like browser type and pages visited to improve site performance.</li>
      </ul>

      <h5>2. How We Use Your Information</h5>
      <ul>
        <li>To respond to inquiries and schedule meetings.</li>
        <li>To improve our services and user experience.</li>
        <li>To comply with legal obligations.</li>
      </ul>

      <h5>3. Sharing of Information</h5>
      <p>We do not sell your information. It may be shared with service providers solely to fulfill your requests.</p>

      <h5>4. Data Security</h5>
      <p>We take reasonable precautions but cannot guarantee absolute security over the internet.</p>

      <h5>5. Your Rights</h5>
      <p>You may request access to, correction of, or deletion of your personal data by contacting us at privacy@pioneeroneglobal.com.</p>

      <h5>6. Changes to This Policy</h5>
      <p>We may update this policy. Revisions will appear on this page with a new effective date.</p>

                </div>
            </div>
        </div>
      </section>
      <Shape/>
      <Footer/>
    </>
  )
}
